<template>
  <v-container fluid>
    <v-card elevation="1" class="mb-4">
      <v-card-title>Service Confirmations</v-card-title>
      <v-card-text>
        <service-confirmation></service-confirmation>
      </v-card-text>
    </v-card>
    <v-card elevation="1" class="mb-4">
      <v-card-title>Service Compliance</v-card-title>
      <v-card-text>
        <service-compliance :data="serviceCompliance"></service-compliance>
      </v-card-text>
    </v-card>
    <v-card elevation="1" class="mb-4">
      <v-card-title>Proof of Payment</v-card-title>
      <v-card-text>
        <pop></pop>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import ServiceConfirmationTableVue from './ServiceConfirmationTable.vue';
import ServiceComplianceTableVue from './ServiceComplianceTable.vue';
import ProofOfPaymentTableVue from '../ProofOfPayment/ProofOfPaymentTable.vue';
import { mapGetters, mapActions } from 'vuex'
const moduleNameSpace = 'serviceCompliance'
export default {
  name: 'AdminScheduler',
  created(){
    this.getServiceCompliance()
  },
  methods:{
    ...mapActions(moduleNameSpace, ['getServiceCompliance'])
  },
  computed: {
    ...mapGetters(moduleNameSpace, ['serviceCompliance'])
  },
  components: {
    'service-confirmation' : ServiceConfirmationTableVue,
    'service-compliance' : ServiceComplianceTableVue,
    'pop' : ProofOfPaymentTableVue
  }
}
</script>
